// extracted by mini-css-extract-plugin
module.exports = {"tenantAuthen":"TenantAuthen_tenantAuthen__2o0UU","scanner":"TenantAuthen_scanner__1jK4L","buttonArea":"TenantAuthen_buttonArea__3gJuz"};